import { CSSProperties } from "react";
import { flexRender, Header } from "@tanstack/react-table";
import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

const SortableTableHead = ({
  header,
  className,
  style,
}: {
  header: Header<any, unknown>;
  className?: string;
  style?: CSSProperties;
}) => {
  const canSort = header.column.getCanSort();
  const sorted = header.column.getIsSorted();
  const isRight = (header.column.columnDef.meta as any)?.align === "right";

  return (
    <TableHead
      className={cn(className, canSort && "cursor-pointer select-none")}
      style={style}
      onClick={canSort ? header.column.getToggleSortingHandler() : undefined}
    >
      <div
        className={cn(
          "inline-flex items-center gap-1",
          isRight && "w-full justify-end"
        )}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
        {canSort ? (
          <span className="inline-flex shrink-0 text-g-400">
            {sorted === "asc" ? (
              <ChevronUp className="h-3.5 w-3.5" />
            ) : sorted === "desc" ? (
              <ChevronDown className="h-3.5 w-3.5" />
            ) : (
              <ChevronsUpDown className="h-3.5 w-3.5 opacity-40" />
            )}
          </span>
        ) : null}
      </div>
    </TableHead>
  );
};

export default SortableTableHead;
